import daycaca from 'daycaca'

const KB = 1024
const MB = KB * 1024
// const GB = MB * 1024
const minFileSize = 1
const maxFileSize = 10 * MB

// Utils Method
const getFileName = (path) => {
  if (path === '') return ''
  // linux / mac os / some safely browser ... will return static fakepath path.
  if (path.substr(0, 12) === 'C:\\fakepath\\') return path.substr(12)
  let x
  x = path.lastIndexOf('/')
  if (x >= 0) return path.substr(x + 1)
  x = path.lastIndexOf('\\')
  if (x >= 0) return path.substr(x + 1)
  return path
}

const getFileSize = (bytes = 0, decimals = 0) => {
  if (bytes === 0) return '0 Bytes'
  const sizes = ['Bytes', 'KB', 'MB', 'GB'] // ...'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'
  const i = Math.floor(Math.log(bytes) / Math.log(KB))
  return `${parseFloat((bytes / Math.pow(KB, i)).toFixed(decimals))}${sizes[i]}`
}

const resizeImage = (base64Str, _maxwidth, _maxheight, callback) => {
  let maxWidth = _maxwidth
  let maxHeight = _maxheight
  let img = new Image()
  img.src = base64Str
  img.onload = () => {
    const MAX_WIDTH = maxWidth || 0
    const MAX_HEIGHT = maxHeight || 0
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    maxWidth = img.width
    maxHeight = img.height

    if (MAX_WIDTH) {
      if (maxWidth > MAX_WIDTH) {
        maxHeight *= MAX_WIDTH / maxWidth
        maxWidth = MAX_WIDTH
      }
    } else if (maxHeight > MAX_HEIGHT) {
      maxHeight = MAX_HEIGHT
      maxWidth *= MAX_HEIGHT / maxHeight
    }

    canvas.width = maxWidth
    canvas.height = maxHeight

    ctx.drawImage(img, 0, 0, maxWidth, maxHeight)
    if (callback) callback(canvas.toDataURL('image/jpeg', 0.9))
  }
}

const rotateImage = (img, degree = 0) =>
  new Promise((resolve) => daycaca.rotate(img, degree, (data, w, h) => resolve({ data, w, h })))

const cropImage = (base64, width, height, callback) => {
  let w = width
  let h = height
  let cropX = 0,
    cropY = 0
  if (w >= h || w * 1.3 >= h) {
    cropX = 0
    cropY = 0
    // h = w * 1.3;
  } else if (w * 1.3 < h) {
    cropX = 0
    cropY = (h - w * 1.3) / 2
    h = w * 1.3
  }
  daycaca.crop(base64, { x: cropX, y: cropY, w, h }, (base64) => {
    resizeImage(base64, 1200, 0, (base64) => callback && callback(base64))
  })
}

// fetch images exif data and get orientation.
// ref1: https://github.com/exif-js/exif-js/issues/63
// ref2: https://github.com/exif-js/exif-js/issues/63#issuecomment-359807684
// ref3: http://wp.mlab.tw/?p=2371
const getOrientation = (file, callback) => {
  const reader = new window.FileReader()
  reader.onload = (e) => {
    const view = new window.DataView(e.target.result)
    // SOI marker(0xFFD8) 若無 表示不是 JPG / JPEG 文件
    if (view.getUint16(0, false) != 0xffd8) {
      return callback(-2)
    }
    let offset = 2
    const length = view.byteLength
    while (offset < length) {
      const marker = view.getUint16(offset, false)
      offset += 2
      if (marker == 0xffe1) {
        // 取出 exif開始資訊(0x45786966) 若無 表示圖片不存在exif資訊
        if (view.getUint32((offset += 2), false) != 0x45786966) {
          return callback(-1)
        }
        // search TIFF Header(0x4949)
        // chack is little endian or big endian
        // 找出圖片資訊的寫入方式是little endian or big endian 不然會影響到之後的 orientation 資訊與判斷
        const little = view.getUint16((offset += 6), false) == 0x4949
        offset += view.getUint32(offset + 4, little)
        const tags = view.getUint16(offset, little)
        offset += 2
        for (let i = 0; i < tags; i++) {
          // 尋找 orientation 資訊 (0x0112)
          if (view.getUint16(offset + i * 12, little) == 0x0112) {
            return callback(view.getUint16(offset + i * 12 + 8, little)) // 回傳圖片 orientation 資訊
          }
        }
      } else if ((marker & 0xff00) != 0xff00) {
        break
      } else {
        offset += view.getUint16(offset, false)
      }
    }
    return callback(-1)
  }
  reader.readAsArrayBuffer(file)
}

const convertToBase64 = (file) => {
  const reader = new FileReader()
  return new Promise((resolve, reject) => {
    ///////////////////////////////////////////////
    // reader.onload = () => resolve(reader.result) // return ori-image 1:1 size
    ///////////////////////////////////////////////
    reader.onload = (() => {
      return (e) => {
        const img = new Image()
        img.onload = () => {
          getOrientation(file, async (Orientation) => {
            switch (Orientation) {
              case 3: // 翻轉180
              case 4: {
                // 垂直鏡像
                const rotateImg = await rotateImage(img, 180)
                cropImage(rotateImg, rotateImg.w, rotateImg.h, resolve)
                break
              }
              case 5: // 水平鏡像後 順時針翻喘270
              case 6: {
                // 順時針翻轉270
                const rotateImg = await rotateImage(img, 90)
                cropImage(rotateImg, rotateImg.w, rotateImg.h, resolve)
                break
              }
              case 7: // 水平鏡像後 順時針翻轉90
              case 8: {
                // 順時針翻轉90
                const rotateImg = await rotateImage(img, 270)
                cropImage(rotateImg, rotateImg.w, rotateImg.h, resolve)
                break
              }
              case 2: // 水平鏡像
              case 1: // 一般
              default: {
                cropImage(img, img.width, img.height, resolve)
                break
              }
            }
          })
        }
        img.src = e.target.result
      }
    })(file)
    ///////////////////////////////////////////////
    reader.onerror = (error) => reject(error, null)
    reader.readAsDataURL(file)
  })
}

const imageFileUploadCheck = (fileInput = null, maxImageUploadLimit = 1) => {
  const errors = []

  // 1. noInputError: Network issue or unknown problem.
  if (!fileInput) {
    errors.push({ type: 'error:noInputError' })
    return errors
  }

  // 2. Maximum number of uploads exceeded. You can upload up to one images at once.
  if (fileInput.files.length > maxImageUploadLimit)
    errors.push({ type: 'error:imageLimitError', limit: maxImageUploadLimit })

  // 3. FileName File format not supported. Formats supported: jpg, jpeg, png, gif...
  Array.prototype.forEach.call(fileInput.files, (file) => {
    const fileName = getFileName(file.name)
    if (!file.type.match('image.*')) errors.push({ type: 'error:imageTypeError', fileName })
  })

  // 4. File Size Limit Check
  Array.prototype.forEach.call(fileInput.files, (file) => {
    const size = file.size || 0
    const fileName = getFileName(file.name)
    if (typeof FileReader !== 'undefined') {
      // `${fileName} File size below minimum (size).`
      if (size <= minFileSize)
        errors.push({
          type: 'error:fileSizeMinimumError',
          fileName,
          size: getFileSize(minFileSize),
        })
      // `${fileName} File size exceeds limit (size).`
      if (size > maxFileSize)
        errors.push({
          type: 'error:fileSizeExceedsError',
          fileName,
          size: getFileSize(maxFileSize),
        })
    }
  })

  return errors
}

const convertFilesToList = async (files, maxImageUploadLimit = 1) => {
  let imageList = []
  const acceptedFiles = Array.prototype.slice
    .call(files, 0, maxImageUploadLimit)
    .filter((file) => file.size >= minFileSize && file.size < maxFileSize)
  try {
    const promises = acceptedFiles.map((file) => convertToBase64(file))
    const files = await Promise.all(promises)
    imageList = files.map((base64, key) => ({
      file: acceptedFiles[key],
      id: `file_upload_${key}`,
      img: base64,
      index: key,
      progress: 0,
    }))
  } catch (err) {
    console.error(err)
  }
  return imageList
}

export { getFileName, getFileSize, convertToBase64, imageFileUploadCheck, convertFilesToList }
